import { Folder, FoldersInvariants } from 'src/models/resumeFolders';

export const MAX_FOLDERS_WITHOUT_SCROLL = 49;

export const MAX_RESUMES_WITHOUT_LINKSWITCH = 5;

export const RESUME_FOLDERS_URL = '/employer/resumefolders';
const RESUME_FOLDER_URL = '/employer/resumefolders/folder';

export const getFolderById = ({ own, shared, trash }: FoldersInvariants, folderId: string): Folder | undefined =>
    own?.[folderId] || shared?.[folderId] || trash?.[folderId];

export const getFolderUrl = (folderId: string): string => {
    return folderId === '-1' ? RESUME_FOLDERS_URL : `${RESUME_FOLDER_URL}?folder=${folderId}`;
};

export interface FolderTypeIntl {
    name: string;
    shared: boolean;
    selected: boolean;
    resumes: number;
}

export interface FoldersGroupTypeIntl {
    [key: string]: FolderTypeIntl;
}

export interface FoldersTypeIntl {
    own: FolderTypeIntl[];
    shared: FolderTypeIntl[];
    trash: FoldersGroupTypeIntl;
    totalResumesCount: number;
    searchFolderIds: string[];
}
